import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const words = t("marquee");

  const strip = (ariaHidden) => (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
      {words.map((word, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-3xl md:text-5xl px-8 whitespace-nowrap ${
              i % 2 === 0 ? "text-gold-gradient" : "text-outline-gold"
            }`}
          >
            {word}
          </span>
          <span className="h-2 w-2 rotate-45 bg-gold/50 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <section className="relative border-y border-gold/25 bg-[#F6F7F9] py-8 overflow-hidden">
      <div className="marquee-track">
        {strip(false)}
        {strip(true)}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-950 to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-950 to-transparent pointer-events-none" />
    </section>
  );
}
